import React, { useEffect, useState, useRef } from "react";
import "./ImageModal.css"; // Подключаем стили

const ImageModal = ({ src, onClose }) => {
    const [scale, setScale] = useState(1); // Масштаб изображения
    const [position, setPosition] = useState({ x: 0, y: 0 }); // Координаты перемещения
    const [isDragging, setIsDragging] = useState(false);
    const startPos = useRef({ x: 0, y: 0 });

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Закрытие по Esc
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    if (!src) return null;

    // Функция для увеличения масштаба
    const zoomIn = () => setScale((prev) => Math.min(5, prev + 0.2));
    // Функция для уменьшения масштаба
    const zoomOut = () => setScale((prev) => Math.max(0.5, prev - 0.2));

    // Функция для обработки колесика мыши
    const handleWheel = (event) => {
        event.preventDefault();
        setScale((prevScale) => Math.min(5, Math.max(0.5, prevScale + event.deltaY * -0.002)));
    };

    // Начало перетаскивания
    const handleMouseDown = (event) => {
        setIsDragging(true);
        startPos.current = { x: event.clientX - position.x, y: event.clientY - position.y };
    };

    // Перетаскивание изображения
    const handleMouseMove = (event) => {
        if (!isDragging) return;
        setPosition({ x: event.clientX - startPos.current.x, y: event.clientY - startPos.current.y });
    };

    // Остановка перетаскивания
    const handleMouseUp = () => setIsDragging(false);

    return (
        <div className="image-modal-overlay" onClick={onClose}>
            <div
                className="image-modal-content"
                onClick={(e) => e.stopPropagation()} // Чтобы не закрывалось при клике на контент
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
                onWheel={handleWheel} // Поддержка колесика мыши
            >
                <button className="image-modal-close" onClick={onClose}>✖</button>

                {/* Кнопки зума */}
                <div className="zoom-controls">
                    <button onClick={zoomIn}>➕</button>
                    <button onClick={zoomOut}>➖</button>
                </div>

                <img
                    src={src}
                    alt="Просмотр изображения"
                    className="image-modal-img"
                    style={{
                        transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                        cursor: scale > 1 ? "grab" : "default",
                    }}
                    onMouseDown={handleMouseDown}
                />
            </div>
        </div>
    );
};

export default ImageModal;
